// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiNftLinkMediaPreview {
    'status': ApiNftLinkMediaPreviewStatusEnum;
    'kind': string | null;
    'card_url': string | null;
    'thumb_url': string | null;
    'small_url': string | null;
    'width': number | null;
    'height': number | null;
    'mime_type': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "status",
            "baseName": "status",
            "type": "ApiNftLinkMediaPreviewStatusEnum",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "string",
            "format": ""
        },
        {
            "name": "card_url",
            "baseName": "card_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "thumb_url",
            "baseName": "thumb_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "small_url",
            "baseName": "small_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "width",
            "baseName": "width",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "height",
            "baseName": "height",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "mime_type",
            "baseName": "mime_type",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiNftLinkMediaPreview.attributeTypeMap;
    }

    public constructor() {
    }
}


export enum ApiNftLinkMediaPreviewStatusEnum {
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Ready = 'READY',
    Failed = 'FAILED',
    Skipped = 'SKIPPED'
}

